export function stripCNPJ(value: string): string {
  const cleaned = value.replace(/[.\-/\s]/g, '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  const base = cleaned.slice(0, 12);
  const checkDigits = cleaned.slice(12).replace(/\D/g, '').slice(0, 2);
  return `${base}${checkDigits}`;
}

export function formatCNPJ(value: string): string {
  const normalized = stripCNPJ(value);

  if (normalized.length <= 2) return normalized;
  if (normalized.length <= 5) return `${normalized.slice(0, 2)}.${normalized.slice(2)}`;
  if (normalized.length <= 8) return `${normalized.slice(0, 2)}.${normalized.slice(2, 5)}.${normalized.slice(5)}`;
  if (normalized.length <= 12)
    return `${normalized.slice(0, 2)}.${normalized.slice(2, 5)}.${normalized.slice(5, 8)}/${normalized.slice(8)}`;
  return `${normalized.slice(0, 2)}.${normalized.slice(2, 5)}.${normalized.slice(5, 8)}/${normalized.slice(8, 12)}-${normalized.slice(12)}`;
}

export function formatCPF(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
}

export function formatCpfOrCnpj(value: string): string {
  const digits = value.replace(/\D/g, '');
  if (digits.length === 11) return formatCPF(value);
  if (digits.length === 14) return formatCNPJ(value);
  return value;
}
